export default {
    layout: {
        loading: 'กำลังทำรายการ',
        trading: 'กำลังทำรายการ'
    },
    footer: {
    },
    menu: {
        home: 'หน้าแรก',
        staking: 'เมทริกซ์',
        port: 'PORT',
        internet: 'เครือข่าย',
        me: 'ของฉัน',
    },
    header: {
        selectLang: 'เลือกภาษา',
        close: 'ปิด',
        trading: 'การซื้อขาย',
        dashboard: 'แดชบอร์ด',
        subscribeMatrix: 'สมัครเมทริกซ์',
        portTaskCenter: 'ศูนย์งาน PORT',
        network: 'เครือข่าย',
        apiBinding: 'เชื่อมโยง API',
        gridTree: 'โครงสร้างกริด',
        account: 'บัญชี',
        documents: 'เอกสารและไวท์เปเปอร์',
        personalCenter: 'ศูนย์ส่วนบุคคล',
        language: 'ภาษา'
    },
    home: {
        recently1:'ชุมชน',
        staticrewares: 'คงที่',
        recentlyName: 'บัญชีแยกประเภท',
        recentlyInfo: 'รายละเอียดรายได้',
        dataUpdate: 'อัปเดตข้อมูล',
        realtime: 'เรียลไทม์·BSC',
        totalRevenue: 'รายได้รวม (USDT)',
        today: 'วันนี้',
        totalTradingVolume: 'มูลค่าการซื้อขายรวม',
        todayEarn: 'รายได้วันนี้',
        share: 'แชร์ให้เพื่อน',
        shareDesc: 'โชว์รายได้ เชิญเพื่อน รับรางวัล',
        directReferrals: 'จำนวนผู้แนะนำตรง',
        teamMembers: 'จำนวนสมาชิกทีม',
        thisWeek: 'สัปดาห์นี้',
        copy: 'คัดลอก',
        recently: 'รายได้ล่าสุด',
        netIncome: 'รายได้สุทธิ',
        dailyAverage: 'เฉลี่ยต่อวัน',
        quantitativeIncome: 'เชิงปริมาณ',
        recommend: 'แนะนำ',
        port: 'PORT',
        bonus: 'โบนัส',
        all: 'ทั้งหมด',
        todayTitle: 'วันนี้',
        loadingMore: 'โหลดเพิ่มเติม',
        recommendBonus: 'รางวัลการแนะนำ',
        portTaskPassed: 'งาน PORT ผ่านแล้ว',
        myProfit: 'กำไร/ขาดทุนของฉัน',
        earningOnBitDeep: 'ฉันทำกำไรบน BitDeep',
        totalRevenueUsdt: 'รายได้รวม · USDT',
        consecutiveDays: 'จำนวนวันต่อเนื่อง',
        scanToJoin: 'สแกนเพื่อเข้าร่วม',
        uid: 'UID',
        referralBonus: 'รางวัลการแนะนำ',
        shareTo: 'แชร์ไปยัง',
        eachReferral: 'รางวัลการแชร์',
        screenshotAndShare: 'แคปหน้าจอและแชร์',
        saveShareEarn: 'บันทึก · ส่งต่อ · รับรางวัล',
        period: 'รอบ',
        netProfit: 'กำไรสุทธิ',
        quantReward: 'รายได้เชิงปริมาณ',
        dailyBonus: 'รางวัลรายวัน PORT',
        close: 'ปิด',
        permission: 'สิทธิ์',
        onlyEnable: 'เปิดใช้งานเท่านั้น',
        enterBitgetUid: 'กรอก BITGET UID',
        slogan: 'คำขวัญ',
        document: 'เอกสาร',
        days: 'วัน',
        taskText: 'งาน',
        minutes: 'นาที',
        decentralizedPortTech: 'สถาปัตยกรรมเทคโนโลยี PoRT แบบกระจายศูนย์ เศรษฐศาสตร์โทเคน BGB และเมทริกซ์แรงจูงใจสองเขต',
        auditReport: 'รายงานการตรวจสอบ',
        faqSupport: 'คำถามที่พบบ่อย & การสนับสนุน',
        telegram: 'Telegram',
        piece: 'ชิ้น',
        faq: 'คำถามที่พบบ่อย',
        faq1: 'จะเชื่อม Bitget API อย่างไร?',
        faq1Desc: 'ไปที่ Bitget Exchange → ตั้งค่า → จัดการ API เพื่อรับ API Key และ Secret เปิดเฉพาะสิทธิ์ Spot Trading ห้ามเปิดสิทธิ์ถอนเด็ดขาด วางคีย์ลงใน BitDeep DApp ทำธุรกรรมทดสอบ 1 USDT จึงจะเปิดใช้งาน',
        faq2: 'PoRT (Proof of Real Trading) คืออะไร?',
        faq2Desc: 'PoRT คือกลไกหลักของแนวคิด "เทรดคือการขุด" ระบบใช้ Bitget API ทำธุรกรรมซื้อขายเร็วของเหรียญที่กำหนด (เช่น BGB) ทุกวันโดยอัตโนมัติ เมื่อปริมาณเทรดเกิน Stake × 50% ระบบจะยืนยันและจ่ายผลตอบแทนรายวัน',
        faq3: 'ต้องคอยเฝ้าหน้าจอเองทุกวันไหม?',
        faq3Desc: 'ไม่ต้อง หลังเชื่อม API แล้ว ระบบจะทำธุรกรรมโดยอัตโนมัติภายในช่วง 24 ชั่วโมง ไม่ต้องทำเอง สามารถตรวจสอบได้ที่เมนู PoRT',
        faq4: 'ALPHA และ SIGMA ต่างกันอย่างไร?',
        faq4Desc: 'ALPHA (เริ่มต้น): สเตค 500 USDT, ผลตอบแทน 0.3–1.3% ต่อวัน, ซื้อได้ 1 ชุดเท่านั้น SIGMA (โปร): สเตค 1,000 USDT, ผลตอบแทน 0.6–1.6% ต่อวัน, ซื้อได้สูงสุด 5 ชุด',
        faq5: 'เงินของฉันปลอดภัยไหม? แพลตฟอร์มแตะต้องเงินของฉันได้หรือไม่?',
        faq5Desc: 'เงินของคุณยังอยู่ในบัญชี Bitget ของคุณเอง 100% API ให้สิทธิ์อ่านและเทรด spot เท่านั้น ระบบไม่สามารถถอนหรือโอนเงินต้นใดๆ ได้',
        faq6: 'รายได้รายวันชำระเมื่อใด?',
        faq6Desc: 'หลัง PoRT ยืนยันสำเร็จ จะชำระในวันถัดไป ระบบจะปล่อยรางวัลคู่ทั้ง USDT และพอยต์ 10x Deep โดยอัตโนมัติ',
        faq7: 'Scout Bonus (รางวัลผู้แนะนำตรง) คำนวณอย่างไร?',
        faq7Desc: 'ทุกบัญชีที่คุณแนะนำตรงและยังใช้งาน คุณจะได้รับรางวัลคงที่รายวัน: บัญชี ALPHA (500 USDT) ได้ 1 USDT/วัน, บัญชี SIGMA (1,000 USDT) ได้ 2 USDT/วัน จนกว่ารอบของบัญชีนั้นจะจบ',
        faq8: 'เลื่อนระดับ (D1–D7) อย่างไร?',
        faq8Desc: 'ระดับอัปเกรดตามยอดสะสมของฝั่งโซนเล็ก เช่น: D1 ต้อง 2,000 USDT, D3 ต้อง 15,000 USDT, D7 (สูงสุด) ต้อง 3,000,000 USDT ระดับยิ่งสูง รางวัลผลต่างระดับยิ่งสูง (D7 สูงสุด 7 USDT/คน/วัน)',
        faq9: 'หนึ่งวงจรกี่วัน? หมดอายุแล้วทำอย่างไร?',
        faq9Desc: 'หนึ่งวงจรคือ 28 วัน เมื่อจบรอบสามารถเลือกสเตคต่อได้ ผลตอบแทนจ่ายตามผลการยืนยัน PoRT จริงรายวัน (อัตราผันแปร)',
        faq10: 'ถอนเงินมีค่าธรรมเนียมไหม?',
        faq10Desc:'ค่าธรรมเนียมถอนเป็น 0 แพลตฟอร์มนำค่าธรรมเนียมกลับเข้าพูลเพื่อเสริม LP สร้างวงจรเชิงบวก',
        bigArea: 'เขตใหญ่',
        smallArea: 'เขตเล็ก',
        enterWithdrawAmount: 'กรอกจำนวนถอน',
        all: 'ทั้งหมด',
        available: 'พร้อมใช้',
        totalAmount: 'จำนวนรวม',
        confirmWithdraw: 'ยืนยันการถอน',
        withdrawRecord: 'ประวัติการถอน',
        withdrawn: 'ถอนแล้ว',
        quickStartGuide:'เริ่มต้นอย่างรวดเร็ว',
        whitepaperGuide:'ไวท์เปเปอร์ & คู่มือ',
        whitepaper:'ไวท์เปเปอร์',
        downloadPdf:'ดาวน์โหลด'
    },
    staking: {
        selectPackage: 'สมัครเมทริกซ์',
        alpha: 'ALPHA',
        beginner: 'ผู้เริ่มต้น',
        sigma: 'SIGMA',
        professional: 'มืออาชีพ',
        popular: 'ได้รับความนิยมมากที่สุด',
        dailyReturn: 'รางวัลจากการทำภารกิจ',
        teamDepth: 'ความลึกของทีม',
        limitPurchase: 'จำกัดการซื้อ',
        layer: 'ชั้น',
        copy: 'ชิ้น',
        autoRenew: 'ต่ออายุอัตโนมัติเมื่อหมดอายุ',
        autoReinvest: 'ส่วนต่างการต่ออายุอัตโนมัติ',
        subscribeAlpha: 'สมัคร Alpha',
        subscribeSigma: 'สมัคร Sigma',
        stakedAmount: 'เงินค้ำประกัน',
        stakedAmount2: 'รอบ',
        stakedAmount3: 'รายได้สะสม',
        stakingTime: 'เวลาที่เข้าร่วม',
        maturityTime: 'เวลาครบกำหนด',
        redeem: 'ไถ่ถอน',
        renew: 'ต่ออายุ',
        autoRenewActive: 'ต่ออายุอัตโนมัติแล้ว',
        autoRenewInactive: 'ยังไม่ได้ต่ออายุอัตโนมัติ',
        smartContract: 'สัญญาอัจฉริยะจัดการ เงินค้ำประกัน 28 วัน และปลดล็อกเมื่อครบกำหนด',
        alter2:'หากคำมั่นสัญญาหมดอายุแล้ว โปรดต่ออายุคำมั่นสัญญา',
    },
    me: {
        account: 'บัญชี',
        my: 'ของฉัน',
        staked: 'เข้าร่วมแล้ว',
        staked1:'เงินค้ำประกัน',
        points: 'คะแนน',
        consecutive: 'จำนวนวันต่อเนื่อง',
        withdraw: 'ถอน',
        language: 'ภาษา',
        simplifiedChinese: 'ภาษาจีนตัวย่อ',
        disconnectWallet: 'ตัดการเชื่อมต่อกระเป๋า',
        level: 'ระดับ',
        joinDate: 'วันที่เข้าร่วม',
        bdId: 'BD-ID'
    },
    bindapi: {
        apiBinding: 'เชื่อมโยง API',
        bindDesc: 'เชื่อมโยง API Key ของคุณเพื่ออนุญาตการซื้อขายเชิงปริมาณ',
        apiKey: 'API Key',
        apiSecret: 'API Secret',
        exchange: 'ตลาดซื้อขาย',
        futures: 'สัญญา',
        spot: 'สปอต',
        readOnly: 'อ่านอย่างเดียว',
        bind: 'เชื่อมโยง',
        riskNote: 'API Key ใช้สำหรับซิงค์ข้อมูลการซื้อขายเท่านั้น ไม่จัดเก็บข้อมูลที่ละเอียดอ่อน',
        apiConnection: 'การเชื่อมต่อ API',
        bindExchangeApi: 'เชื่อมโยง API ตลาดซื้อขาย',
        bitDeepRead: 'BitDeep อ่านคำสั่งจากบัญชี CEX ของคุณเพื่อยืนยันการซื้อขายจริง (PoRT)',
        noWithdraw: 'เราไม่เคยแตะต้องการถอนของคุณ',
        securityTip: 'คำแนะนำด้านความปลอดภัย·โปรดอ่านอย่างละเอียด',
        close: 'ปิด',
        withdraw: 'ถอน',
        permission: 'สิทธิ์',
        onlyEnable: 'เปิดใช้งานเท่านั้น',
        spotTrading: 'การซื้อขายสปอต',
        read: 'อ่าน',
        recommendedPartner: 'พันธมิตรที่แนะนำ',
        zeroFee: 'ค่าธรรมเนียม 0%',
        activated: 'เปิดใช้งานแล้ว',
        classicAccount: 'บัญชีคลาสสิก',
        unifiedAccount: 'บัญชีรวม',
        bindBitgetApi: 'เชื่อมโยง Bitget API',
        upcoming: 'เร็วๆ นี้',
        underAudit: 'อยู่ระหว่างการตรวจสอบ',
        expected: 'คาดว่า'
    },
    port: {
        portTaskCenter: 'ศูนย์งาน PORT',
        dailyTask: 'งานประจำวัน',
        verify: 'ตรวจสอบ',
        completed: 'เสร็จสิ้น',
        incomplete: 'ยังไม่เสร็จ',
        verifyStandard: 'มาตรฐานการตรวจสอบ',
        tradingVolume: 'มูลค่าการซื้อขาย',
        today: 'วันนี้',
        deadline: 'กำหนดเวลา',
        reward: 'รางวัล',
        startVerify: 'เริ่มตรวจสอบ',
        verifying: 'กำลังตรวจสอบ',
        verified: 'ตรวจสอบแล้ว',
        insufficient: 'ไม่ถึงเกณฑ์',
        viewDetails: 'ดูรายละเอียด',
        taskList: 'รายการงาน',
        allTasks: 'งานทั้งหมด',
        completedTasks: 'เสร็จสิ้น',
        pendingTasks: 'รอดำเนินการ',
        proofOfRealTrading: 'หลักฐานการซื้อขายจริง',
        todayTask: 'งานวันนี้',
        todayStaticIncome: 'รางวัลภารกิจวันนี้',
        points: 'คะแนน',
        todayWindowClosesAt: 'หน้าต่างวันนี้ปิดเวลา',
        checkTaskStatus: 'ตรวจสอบสถานะงาน',
        teamProgress: 'ความคืบหน้าของทีม · วันนี้',
        realtimePortCompletion: 'สถานะการเสร็จสิ้น PORT แบบเรียลไทม์',
        completedText: 'เสร็จสิ้น',
        pendingText: 'รอดำเนินการ',
        realtimeApiValidationFlow: 'เรียลไทม์ · API · กระบวนการตรวจสอบ',
        rewardRemark1:'Global Dividend',
        rewardRemark2:'Level-Differential Bonus',
        rewardRemark3:'Scout Bonus',
        rewardRemark4:'Task Reward',
        rewardRemark5:'PoRT Task Success',
    },
    internet: {
        network: 'เครือข่าย',
        treeBrowser: 'เบราว์เซอร์แบบต้นไม้',
        searchAddress: 'ค้นหา 0x...ที่อยู่ หรือ BD-ID',
        totalTradingVolume: 'มูลค่าการซื้อขายรวม',
        members: 'สมาชิก',
        networkStructure: 'โครงสร้างเครือข่าย',
        allLevels: 'ทุกระดับ',
        addRemark: 'เพิ่มหมายเหตุ',
        enterRemark: 'กรอกหมายเหตุ',
        cancel: 'ยกเลิก',
        confirm: 'ยืนยัน',
        alert1:'Share Performance',
    alert2:'Team Performance',
    alert3:'Task Status',
    },
    withdraw: {
        withdraw: 'ถอน',
        usdtAsset: 'สินทรัพย์ USDT',
        withdrawAmount: 'จำนวนเงินถอน',
        availableBalance: 'ยอดคงเหลือที่ใช้ได้',
        fee: 'ค่าธรรมเนียม',
        actualArrival: 'จำนวนที่ได้รับจริง',
        submit: 'ส่ง',
        withdrawSuccess: 'ถอนสำเร็จ',
        withdrawFailed: 'ถอนล้มเหลว',
        processing: 'กำลังดำเนินการ',
        completed: 'เสร็จสิ้น',
        withdrawHistory: 'ประวัติการถอน'
    },
    popup: {
        taskUnfinished: 'งานยังไม่เสร็จ',
        taskUnfinishedDesc: 'ข้อมูลการซื้อขายไม่ถึงมาตรฐานการตรวจสอบ PoRT วันนี้',
        todayTradingVolume: 'มูลค่าการซื้อขายวันนี้',
        remaining: 'เหลือ',
        toComplete: 'เพื่อให้งานวันนี้เสร็จสิ้น',
        tradingVolumeThreshold: '',
        deadline: 'เวลาที่เหลือก่อนงานหมดเขต',
        tryAgain: 'ลองใหม่ภายหลัง',
        goTrade: 'ไปซื้อขาย',
        taskCompleted: 'งานตรวจสอบผ่านแล้ว',
        taskCompletedDesc: 'หลักฐานการซื้อขาย PoRT วันนี้ถูกบันทึกบนบล็อกเชนเรียบร้อย',
        rewardIssued: 'รางวัลถูกแจกจ่ายแล้ว',
        complete: 'เสร็จสิ้น',
        shareTitle: 'แชร์คำเชิญ',
        shareDesc: 'เชิญเพื่อนสมัคร ทั้งสองฝ่ายจะได้รับรางวัล',
        referralLink: 'ลิงก์เชิญ',
        qrCode: 'QR โค้ด',
        copyLink: 'คัดลอกลิงก์',
        notask:'ไม่มีภารกิจวันนี้',
        notaskDesc:'ขณะนี้ไม่มีภารกิจซื้อขาย PoRT ที่รอดำเนินการ',
    }
};
